import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

let CoffeeIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    className={makeClassName('CoffeeIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 8h1a4 4 0 0 1 0 8h-1"
    ></path>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
    ></path>
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="6"
      y1="1"
      x2="6"
      y2="4"
    ></line>
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="10"
      y1="1"
      x2="10"
      y2="4"
    ></line>
    <line
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      x1="14"
      y1="1"
      x2="14"
      y2="4"
    ></line>
    {/* <path
      d="M12,23C5.93,23,1,18.07,1,12S5.93,1,12,1s11,4.93,11,11S18.07,23,12,23z M12,3c-4.96,0-9,4.04-9,9c0,4.96,4.04,9,9,9
	c4.96,0,9-4.04,9-9C21,7.04,16.96,3,12,3z"
    />
    <path
      d="M11.92,14c-0.42,0-0.81-0.26-0.95-0.68c-0.17-0.52,0.11-1.09,0.63-1.27c0.6-0.2,2.32-1.02,2.32-2.05
	c0-0.85-0.54-1.61-1.34-1.89c-1.04-0.36-2.18,0.18-2.55,1.22c-0.18,0.52-0.75,0.8-1.28,0.61C8.24,9.76,7.96,9.19,8.15,8.67
	c0.73-2.08,3.02-3.17,5.1-2.45c1.6,0.56,2.68,2.08,2.67,3.78c0,2.64-3.31,3.82-3.68,3.95C12.13,13.98,12.02,14,11.92,14z"
    />
    <path d="M12.01,18c-0.55,0-1-0.45-1-1s0.44-1,1-1h0.01c0.55,0,1,0.45,1,1S12.56,18,12.01,18z" /> */}
  </svg>
);

export default CoffeeIcon;
